'use strict';

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var typography = require('@alfalab/core-components/typography');
var spinner = require('@alfalab/core-components/spinner');
var link = require('@alfalab/core-components/link');
var core_smsCountdown_smsCountdown = require('../../sms-countdown/sms-countdown.js');
var core_autosubmitInput_autosubmitInput = require('../../autosubmit-input/autosubmit-input.js');
require('./sms-sign-confirmation.css');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент подписания действия с помощью смс. Предполагается для использования внутри модального окна,
 * хотя может быть использован и без него.
 */
var SmsSignConfirmation = /** @class */ (function (_super) {
    tslib.__extends(SmsSignConfirmation, _super);
    function SmsSignConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('sms-sign-confirmation');
        _this.handleInputKeyDown = function (event) {
            var onInputFinished = _this.props.onInputFinished;
            // ENTER keyCode
            if (event.keyCode === 13) {
                onInputFinished(event.target.value);
            }
        };
        _this.handleSmsRetryClick = function (event) {
            var onSmsRetryClick = _this.props.onSmsRetryClick;
            onSmsRetryClick(event);
            _this.focus();
        };
        _this.handleSmsHintLinkClick = function (event) {
            var onSmsHintLinkClick = _this.props.onSmsHintLinkClick;
            if (onSmsHintLinkClick) {
                onSmsHintLinkClick(event);
            }
        };
        _this.handleInputFinished = function (_, payload) {
            var onInputFinished = _this.props.onInputFinished;
            onInputFinished(payload.value);
            if (_this.input) {
                _this.input.blur();
            }
        };
        _this.handleInputChange = function (_, payload) {
            var onInputChange = _this.props.onInputChange;
            if (onInputChange) {
                onInputChange(payload.value);
            }
        };
        _this.handleCountdownFinished = function () {
            var onCountdownFinished = _this.props.onCountdownFinished;
            if (onCountdownFinished) {
                onCountdownFinished();
            }
        };
        _this.setInputRef = function (input) {
            var inputRef = _this.props.inputRef;
            _this.input = input;
            if (inputRef) {
                inputRef(input);
            }
        };
        _this.setSmsCountdownRef = function (smsCountdown) {
            var smsCountdownRef = _this.props.smsCountdownRef;
            if (smsCountdownRef) {
                smsCountdownRef(smsCountdown);
            }
        };
        return _this;
    }
    SmsSignConfirmation.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        // устанавливаем фокус на поле для ввода при появлении окна, при возникновении ошибки и при "включении" поля для ввода
        if ((this.props.error && !prevProps.error)
            || (!this.props.isProcessing && prevProps.isProcessing)) {
            if (this.focusTimeout) {
                clearTimeout(this.focusTimeout);
            }
            this.focusTimeout = setTimeout(function () {
                _this.focusTimeout = null;
                _this.focus();
            }, 0);
        }
    };
    SmsSignConfirmation.prototype.componentWillUnmount = function () {
        if (this.focusTimeout) {
            clearTimeout(this.focusTimeout);
        }
    };
    SmsSignConfirmation.prototype.render = function () {
        var _a = this.props, title = _a.title, phone = _a.phone, value = _a.value, isProcessing = _a.isProcessing, hasPhoneMask = _a.hasPhoneMask, hasSmsCountdown = _a.hasSmsCountdown, isSmsHintVisible = _a.isSmsHintVisible, additionalContent = _a.additionalContent, countdownDuration = _a.countdownDuration, requiredCharAmount = _a.requiredCharAmount, initiallyDisplayCountdown = _a.initiallyDisplayCountdown;
        return (React__default.default.createElement("div", { className: this.cn() },
            React__default.default.createElement(typography.Typography.TitleResponsive, { view: "xsmall", tag: "h4", className: this.cn('header') }, title),
            React__default.default.createElement("div", { className: this.cn('input-container') },
                React__default.default.createElement(core_autosubmitInput_autosubmitInput, { className: this.cn('input'), ref: this.setInputRef, requiredChars: requiredCharAmount, disabled: isProcessing, error: this.displayedError, value: value, onFinished: this.handleInputFinished, onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown })),
            isProcessing && (React__default.default.createElement("div", { className: this.cn('spin') },
                React__default.default.createElement(spinner.Spinner, { size: "s", visible: isProcessing }))),
            hasSmsCountdown && (React__default.default.createElement("div", { className: this.cn('countdown', { hidden: isProcessing }) },
                React__default.default.createElement(core_smsCountdown_smsCountdown.default, { ref: this.setSmsCountdownRef, duration: countdownDuration, initiallyDisplayCountdown: initiallyDisplayCountdown, format: "minutes", phone: phone, hasPhoneMask: hasPhoneMask, retryText: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u043C\u043E\u0436\u043D\u043E", buttonText: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E", onRepeatSms: this.handleSmsRetryClick, onCountdownFinished: this.handleCountdownFinished }))),
            isSmsHintVisible && (React__default.default.createElement("div", { className: this.cn('retry-hint', { 'with-addition-content': Boolean(additionalContent) }) },
                React__default.default.createElement(link.Link, { onClick: this.handleSmsHintLinkClick }, "\u041D\u0435 \u043F\u0440\u0438\u0445\u043E\u0434\u0438\u0442 \u0441\u043C\u0441?"))),
            React__default.default.createElement("div", { className: this.cn('additional-content') }, additionalContent)));
    };
    Object.defineProperty(SmsSignConfirmation.prototype, "displayedError", {
        get: function () {
            var _a = this.props, isProcessing = _a.isProcessing, error = _a.error;
            return isProcessing ? '' : error;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Устанавливает фокус на элемент инпута.
     */
    SmsSignConfirmation.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    SmsSignConfirmation.defaultProps = {
        requiredCharAmount: 4,
        countdownDuration: 60000,
        isSmsHintVisible: false,
        error: '',
        title: 'Введите код из\xa0смс',
        hasSmsCountdown: true,
        initiallyDisplayCountdown: true,
    };
    return SmsSignConfirmation;
}(React.PureComponent));

module.exports = SmsSignConfirmation;
